import { API_ORIGIN } from './apiBase';

export class ApiError extends Error {
    constructor(message, status, code) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
    }
}

async function readBody(response) {
    const text = await response.text();
    if (!text) return null;
    try { return JSON.parse(text); }
    catch { return text; }
}

// The one browser request boundary. It consistently parses errors, supports
// cancellation, and never adds JSON headers to FormData uploads.
export async function apiRequest(path, { token, headers, body, signal, ...options } = {}) {
    const isFormData = body instanceof FormData;
    const response = await fetch(`${API_ORIGIN}${path}`, {
        ...options,
        signal,
        body,
        headers: {
            ...(body && !isFormData ? { 'Content-Type': 'application/json' } : {}),
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(headers || {})
        }
    });
    const data = await readBody(response);
    if (response.status === 413) {
        throw new ApiError('The content is too large to send. Please shorten it and try again.', 413);
    }
    if (!response.ok) {
        throw new ApiError(data?.message || data?.error || `Request failed (${response.status})`, response.status, data?.code);
    }
    return data;
}

export function jsonBody(value) {
    return JSON.stringify(value);
}
